const LABELS = {
  parcels_taken: 'Taken', parcels_delivered: 'Delivered', parcels_collected: 'Collected',
  parcels_returned: 'Returned', kilometres: 'KM',
};
const when = (iso) => new Date(iso).toLocaleString('en-ZA', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });

export const describeChanges = (changes) =>
  Object.entries(changes || {}).map(([k, [a, b]]) => `${LABELS[k] || k} ${a} → ${b}`).join(', ');

export default function EditedNote({ history, testId }) {
  if (!history?.length) return null;
  const last = history[history.length - 1];
  const tip = history.map((h) => `${when(h.at)} · ${h.by}: ${describeChanges(h.changes)}`).join('\n');
  return (
    <div className="mt-0.5 text-[10px] leading-tight text-amber-700" title={tip} data-testid={testId}>
      Edited by {last.by} · {when(last.at)}
      <div className="text-slate-500">{describeChanges(last.changes)}{history.length > 1 ? ` (+${history.length - 1} earlier)` : ''}</div>
    </div>
  );
}
